import * as signalR from "@microsoft/signalr";

export default class Constants {
    public static readonly ClientTickLength: number = 1000; // 1 second
    public static readonly ClientTimerOffsetBuffer: number = 2000; // 2 seconds
    public static readonly CurrencyShortFormat = "$0[,0]";
    public static readonly UnscheduledTime: string = "0001-01-01T00:00:00Z";
    public static readonly DefaultBidIncrement: number = 10000; // $10,000
    public static readonly DefaultHoursAfterStartTime: number = 2;
    public static readonly EmailRegExp: RegExp =
        /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i;
    public static readonly EnBlocDurationMinutes: number = 15;
    public static readonly EnBlocStartWindowMinutes: number = 15;
    public static readonly IsIE: boolean =
        navigator.userAgent.indexOf("MSIE ") > -1 ||
        navigator.userAgent.indexOf("Trident/") > -1;
    public static readonly NodeEnvironmentDev = "development";
    public static readonly ScrollAnimationLength = 800; // 0.8 seconds
    public static readonly SignalrLogLevel = signalR.LogLevel.Error;
    public static readonly SignalrLogLevelDev = signalR.LogLevel.Debug;
    public static readonly UrlCreateAuction = "create";
    public static readonly UrlCreateUser = "create";
    public static readonly ViewDeploys = "view-deploys";

    public static readonly Routes = {
        AdminAuctionDetail: (url?: string) =>
            `/admin/auctions/${url || ":url"}`,
        AdminAuctionList: () => "/admin/auctions",
        AdminUserDetail: (id?: string) => `/admin/users/${id || ":id"}`,
        AdminUserList: () => "/admin/users",
        AuctionDetail: (url: string, config: { baseUrl: string }) =>
            new URL(`/auctions/${url}`, config.baseUrl || "https://clhbid.com"),
        AuctionList: (config: { baseUrl: string }) =>
            new URL("/auctions", config.baseUrl || "https://clhbid.com"),
        ParcelDetails: (
            auctionUrl: string,
            parcelUrl: string,
            config: { baseUrl: string }
        ) =>
            new URL(
                `/auctions/${auctionUrl}/parcels/${parcelUrl}`,
                config.baseUrl || "https://clhbid.com"
            ),
        ForgotPassword: () => "/forgotpassword",
        Home: () => "https://www.clhbid.com/",
        Login: () => "/login",
        Logout: () => "/logout",
        Parcels: (url?: string) => `/auctions/${url || ":url"}/parcels`,
        PasswordReset: (token?: string) =>
            `/passwordreset/${token || ":token"}`,
        Profile: () => "/profile",
        Register: () => "/register",
        TermsAndConditions: (config: { baseUrl: string }) =>
            new URL(
                "/terms-and-conditions",
                config.baseUrl || "https://clhbid.com"
            )
    };

    public static CurrentDate = () => new Date();
    public static SetDocumentTitle(title: string) {
        document.title = `${title} | CLHbid`;
    }

    public static readonly GAEvents = {
        SignUp: "sign_up",
        Login: "login",
        Form: {
            Submit: "form_submit",
            Invalid: "form_invalid_submission"
        }
    };

    public static readonly StackAdaptEvents = {
        CompleteRegistration: "CompleteRegistration",
        PlaceBid: "PlaceBid",
        PlaceHighestBid: "PlaceHighestBid",
        UserLogin: "UserLogin"
    };
}
